import { usePropertyContext } from '../context/PropertyContext/usePropertyContext';
export const useProperty = () => usePropertyContext().property;